<template>
  <div class="universal addcourse addcourseware coursewareModle commonAddcourse">
    <!--面包屑-->
    <div class="crumbs">
      <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
      <span><router-link :to="{name:'TeachManage'}">教学管理</router-link></span> >
      <span>新建课程</span>
    </div>
    <!--搜索框-->
    <div class="search medicalNews medical">
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item :span="10" label="课程名称  :" prop="subject">
              <el-col :span="15">
                <el-input v-model="form.subject"  placeholder="请输入课程名称"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :span="10" label="课程时间  :" prop="courseTime">
              <el-col :span="15">
                <div class="block">
                  <el-date-picker
                    v-model="form.courseTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm"
                    :disabled="isUseable"
                    placeholder="选择日期时间"
                    @change="_dateChange">
                  </el-date-picker>
                </div>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :span="10" label="授课人  :"  prop="teacher">
              <el-col :span="15">
                <el-input v-model="form.teacher" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="教学方式  :" prop="mutual">
              <el-radio-group v-model="form.mutual" @change="_mutualSelect">
                <el-radio :label="1">直播授课</el-radio>
                <el-radio :label="2">自主学习</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :span="10" label="课程分类  :">
              <el-col :span="15">
                <el-select style="width: 100%;" v-model="selectCurse" placeholder="请选择">
                  <el-option v-for="item in cursetypeList"
                             :key="item.consId"
                             :label="item.consDesc"
                             :value="item.consId"
                             >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :span="10" label="学科分类  :">
              <el-col :span="15">
                <el-select style="width: 100%;" v-model="selectSubject" placeholder="请选择">
                  <el-option v-for="item in subjectList"
                             :key="item.consId"
                             :label="item.consDesc"
                             :value="item.consId">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否公开  :" prop="openFlag">
              <el-radio-group v-model="form.openFlag" @change="_radioSelect">
                <el-radio :label="1">公开</el-radio>
                <el-radio :label="2">私人</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="16" v-show="scopeShow">
            <el-form-item :span="10" label="开放范围  :">
              <el-col :span="20">
                <el-input @focus="_openScope" v-model="openMember" placeholder="请选择开放范围"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程封面  :">
              <div class="avatar-uploader">
                <input type="file" accept="image/jpeg,image/jpg,image/png,image/bmp" class="file-upload" @change="uploadPic">
                <img v-if="showImg" :src="courseImg" class="avatar" ref="avatar">
                <!-- <img v-if="oldCourseImg" :src="oldcourseImg" class="avatar"> -->
                <i v-else class="el-icon-plus avatar-uploader-icon"><span class="avatar-icon">点击上传图片</span></i>
              </div>
              <span class="upper-txt">支持3M内.png、.jpg、.bmp格式上传</span>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item :span="10" label="标签  :">
              <el-col :span="24">
                <!-- <el-input v-model="keywords" placeholder="请输入关键词，用逗号隔开"></el-input> -->
                <div style="display: inline-block;">
                <el-tag
                  style="vertical-align: top;line-height: 31px; height: 31px;margin-right: 10px;"
                  :key="index"
                  v-for="(tag,index) in keywords"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)">
                  {{tag}}
                </el-tag>
                <div v-if="keywords.length<4" style="display: inline-block; ">
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="keyWordInputValue"
                    ref="saveTagInput"
                    size="small"
                    :maxlength="6"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  >
                  </el-input>
                  <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 点击添加关键词</el-button>
                </div>

              </div>

              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="8">
          </el-col>
          <el-col :span="16">
            <el-form-item :span="10" label="课程简介  :" prop="remark">
              <el-col :span="20">
                <el-input v-model="form.remark" :maxlength="200"  placeholder="请输入课程简介,最多200字" type="textarea" rows="3">{{remark}}</el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 手风琴 -->
    <div class="accordion">
      <div style="margin-bottom: 20px; margin-top: 10px;">
        <i class="headTip"></i>
        <span style="font-size: 18px;font-weight: bold;color: #000;">课程资料</span>
        <div v-show="addBtn" class="addBtn_class" @click="_addBtn(3)">从教学课件选择</div>
      </div>
      <el-collapse accordion @change = "_accordionChange">
        <el-collapse-item :name="1">
          <template slot="title">
            <span class="font1" >相关影像</span><span class="titletext">已选择 <span>{{num1}}</span> 条影像</span><span class="redact">{{redactchange1}}</span><div v-show="addBtn" class="addBtn" @click="_addBtn(1)">从本院影像选择</div>
          </template>
          <p-table :operationWidth="operationWidth" :head="head" :data="data" :operation="operation" @_operation="_operation_" :autoheight="autoH"></p-table>
        </el-collapse-item>
        <el-collapse-item :name="2">
          <template slot="title">
            <span class="font1" >相关病例</span><span class="titletext">已选择 <span>{{num2}}</span> 条病例</span><span class="redact">{{redactchange2}}</span><div v-show="addBtn" class="addBtn" @click="_addBtn(2)">从病例库中选择</div>
          </template>
          <p-table :head="headVal" :data="dataVal" :operation="operation2" @_operation="_operation2_" :autoheight="autoH"></p-table>
        </el-collapse-item>
        <el-collapse-item :name="3">
          <template slot="title">
            <span class="font1">其他附件</span><span class="titletext">已上传 <span>{{num3}}</span> 个附件</span><span class="redact">{{redactchange3}}</span>
          </template>
          <upload @fileChange="fileChange" @fileRemove="fileRemove" :updateFileList="updateFileList" :updatePicList="updatePicList"></upload>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!--确定取消按钮__-->
    <div class="btn-box">
      <el-button @click="_AddCourse('form',0)"  class="savef">{{saveTxT}}</el-button>
      <el-button @click="_AddCourse('form',1)"  class="cancef">直接上架</el-button>
    </div>
    <!--从教学课件选择-->
    <pops v-if="teachClassPop" :show="teachClassPop" :title="'从教学课件选择'" @closePop="closeTeachClass" :class="'mrDialog'" :width="'980px'">
      <tClass  @teachClassSelect="teachClassSelect" @teachClassSelectClose="teachClassSelectClose"></tClass>
    </pops>
    <!--从本院影像中选择-->
    <pops v-if="hospitalPop" :show="hospitalPop" :title="'从本院影像中选择'" @closePop="closeHospit" :class="'mrDialog'" :width="'980px'">
      <pImage @_popshow="receiveVal" @_popClose="receiveClose" :studyList="studyList"></pImage>
    </pops>
    <!--从病例库中选择-->
    <pops v-if="popCase" :show="popCase" :title="'从病例库中选择'" @closePop="closePopCase" :width="'75%'">
      <div class="popScore popCourse queryCourse">
        <div class="popContent clearfix">
          <div class="leftCont medicalRecord_left">
            <div class="margin10_box medicalRecord_left">
              <collapse-medical-record @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl"
                                       @delPerson="delPerson" @personClick="personClick"
                                       @searchClick="searchClick" :personList="personList" @addPersonList="addPersonList" :treeData="treeData"
                                       @treeNodeClick="treeNodeClick" :titleList="titleList" :filterText="filterText">
              </collapse-medical-record>
            </div>
          </div>
          <div class="rightCont">
            <div class="rightTitle">
              <span class="alreadyChoose">当前您已选择<i class="difColor">{{number}}</i>条病例</span>
              <span class="saveInput">
                <input v-model="search" class="_input" placeholder="请输入关键字搜索" type="text">
                <i class="point el-icon-search" @click="tableCaseList"></i>
              </span>
            </div>
            <div class="borderCont">
              <zTable :head="head3" :data="tableData" :TableData="TableData" :height="height" @tableVal="tableVal" @ValLength="ValLength" ref="getSelection"></zTable>
              <page :total="page.total" :allPage="page.allPage" :pagerCount="5" :currentPage="page.currentPage" @current-page="__currentPage" :page-size="page.pageSize" @page-size="__pageSize"></page>
            </div>
          </div>

                <div class="btn-box">
                  <el-button class="save" @click="addDataVal">添加</el-button>
                  <el-button @click="_cancelCanse" class="cancel">取消</el-button>
                </div>
        </div>


      </div>
    </pops>
     <!--开放范围弹框-->
    <openFlagPop ref="getFlag" @openMemberVal="openMemberVal" @openMemberData="openMemberData"></openFlagPop>

    <!--病例详情弹框-->
    <casePop ref="getCase"></casePop>

    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>

    <fullscreen  :loadingText="loadingText" :isFullscreen="loading"></fullscreen>
  </div>
</template>

<script type="text/ecmascript-6">
  import openFlagPop from '@/components/common/pops/openFlagPop'
  import casePop from '@/components/common/pops/casePop'
  import btns from '@/components/common/button/buttons'
  import collapse from '@/components/common/collapse/collapse'
  import tabs from '@/components/common/tabs/tabs'
  import tree from '@/components/common/tree/tree'
  import radiusInput from '@/components/common/radiusInput/radiusInput'
  import pTable from '@/components/common/tables/publicTable'
  import zTable from '@/components/common/tables/table'
  // import alonebutton from '@/components/common/button/aloneButton'
  import pops from '@/components/common/pops/pop'
  import page from '@/components/common/page/page'
  import upload from "@/components/common/upload/uploadFile1"
  import pImage from '@/components/common/Image/imageSelection'
  import collapseMedicalRecord from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import axios from 'axios'
  import moment from 'moment';
  import {message} from '@/common/js/messages'
  import {nomalTime} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage, clearLocalStorage} from '@/common/js/localStorage'
  import {changehosArea,changeAge,changeGender,changeSex,changeclinicType} from '@/common/js/change'

  import aycanImages from '@/components/common/base/aycanImages'
  import tClass from '@/components/common/Image/teachClassSelection'//教学课件选择组件
  import fullscreen from '@/components/common/base/fullscreen'//全屏遮罩
  export default {
    components: {
      openFlagPop,
      casePop,
      collapse,
      tabs,
      tree,
      radiusInput,
      pTable,
      zTable,
      // alonebutton,
      collapseMedicalRecord,
      pops,
      page,
      upload,
      pImage,
      btns,
      aycanImages,
      tClass,
      fullscreen
    },
    data() {
      return {
        loading: false,
        loadingText:"提交中，请稍后.......",
        aOldResult: [],
        openMember:'',
        saveTxT:'保存',
        isUseable:false,
        showImg:false,
        courseImg: '',
        imgInfo:[],
        courseTime:'', //
        personFlag: '0',
        disabled:false,
        num1:0,
        num2:0,
        num3:0,
        redactchange1:'编辑',
        redactchange2:'编辑',
        redactchange3:'编辑',
        page: {
          total: 0,
          currentPage: 0,
          pageSize: 10
        },

        // dialogImageUrl: '',
        // dialogVisible: false,
        teachClassPop:false,//控制是否显示 从教学课件选择 框
        hospitalPop: false,
        pop: false,
        memberTrue: false,
        memberNull: true,
        popCase: false,
        popDetail: false,
        popSaveData: false,
        scopeShow: false,
        activeName1: '',
        activeName: '1',
        search:'',
        openMemberList: [],
        keyId:[],
        keyId2:[],
        parKeyId:[],
        parKeyId2:[],
        updateFileList: [],
        updatePicList: [],
        member:'',
        number:'0',
        operationWidth: '100',
        activeType: 'first',
        text: '从本院影像选择',
        addBtn: true,
        selectCurse:'1',
        selectSubject: '',
        form: {
          CurseName: '',
          subject: '',
          CurseName2: '',
          teacher: '',
          courseTime:'',
          remark:'',
          CurseType: '',
          openFlag: 1,
          mutual: 1
        },
        deptName: '',
        founder: '',
        medicDetail:'',
        isPerson: false,
        showCheckBox: false,
        treeData: [],
        height: 290,
        autoH:null,
        openFlag: 1,
        mutual:1,
        remark: '',
        groupName:'',
        GroupName:'',
        medicalVal:'',
        treeList: [],
        treeList1: [],
        treeList2: [],
        titleList: [
          { title: "自定义分类", name: "4" },
          { title: "按诊断分类", name: "1" },
          { title: "按部位分类", name: "2" },
          { title: "按科室分类", name: "3" }
        ],
        personList: [],
        tabs: [
          {label: '公共分类', name: '0'},
          {label: '个人分类', name: '1'}
        ],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        rules: {
          subject: [
            {required: true, message: '请输入课程名称', trigger: 'blur'},
            { min: 1, max: 20, message: '名称长度不能超过20个字', trigger: 'blur' }
          ],
          remark:[
            {min: 0, max: 200, message: '简介不能超过200个字', trigger: 'change' }
          ],
          courseTime: [//此处传string类型ie11不认
            {type: 'date',required: true,message: '请输入课程时间', trigger: 'change'}
          ],
          mutual: [
            {required: true}
          ],
          openFlag: [
            {required: true}
          ]
        },
        options: [{
          value: '0',
          label: '男'
        }, {
          value: '1',
          label: '女'
        }],
        sex: '',
        options2: [{
          value: '1',
          label: '岁'
        }, {
          value: '2',
          label: '月'
        }],
        garal: '岁',
        tableKeyWords:'',
        filterText:'',
        deptId:'',
        commonUserId:'',
        keywords:[],//关键字
        inputVisible: false,//关键字点击时显示input框
        keyWordInputValue: '',//单个关键字内容

        rightTabActive: "1",
        hospitalId: '',
        head: [
          {
            props: 'hospitalName',
            label: '来源',
            width: '10%'
          },{
            props: 'patientId',
            label: '患者编号',
            width: '12%'
          },{
            props: 'accessionNumber',
            label: '检查号',
            width: '10%'
          },{
            props: 'patientName',
            label: '患者姓名',
            width: '12%'
          },
          {
            props: 'examTypeName',
            label: '检查类型',
            width: '8%'
          },
          {
            props: 'examBodyName',
            label: '检查部位',
            width: '8%'
          },
          {
            props: 'examDate',
            label: '检查时间',
            width: '8%'
          }
        ],
        headVal:
          [
            {
              props: "caseName",
              label: "病例名称"
            },
            {
              props: "privateType",
              label: "访问权限"
            },
            {
              props: "caseSex",
              label: "性别"
            },
            {
              props: "caseAge",
              label: "年龄"
            },
            {
              props: "createDateStr",
              label: "创建时间"
            },
            {
              props: "creatorName",
              label: "创建人"
            }
          ],
        head3: [
          {
            props: "caseName",
            label: "病例名称"
          },
          {
            props: "privateType",
            label: "访问权限"
          },
          {
            props: "caseSex",
            label: "性别"
          },
          {
            props: "caseAge",
            label: "年龄"
          },
          {
            props: "createDateStr",
            label: "创建时间"
          },
          {
            props: "creatorName",
            label: "创建人"
          }
        ],
        data: [],
        data3: [],
        data4: [],
        dataVal: [],
        groupIds: [],
        tableData: [],
        TableData:[],
        operation: [
          {
            name: '阅片',
            operation: '',
            class: 'icon-yuepian'
          },
          {
            name: '移除',
            operation: '',
            class: 'icon-yichu'
          }
        ],
        operation2: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '移除',
            operation: '',
            class: 'icon-yichu'
          }
        ],
        cursetypeList: [],
        subjectList: [],
        caseList: [],
        attachList: [],
        oldAttachList: [],
        typeName: '',
        studyList:[],
        thirtyMin:'',
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        },
        teachClassData:[],
      }
    },
    mounted() {
      this.autoH = null
    },
    methods: {
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let keyWordInputValue = this.keyWordInputValue;
        if (keyWordInputValue) {
          this.keywords.push(keyWordInputValue);
        }
        this.inputVisible = false;
        this.keyWordInputValue = '';
      },
      handleClose(tag) {//删除标签
        this.keywords.splice(this.keywords.indexOf(tag), 1);
      },
      defaultTime(){
        let date = new Date()
        let addTime = date.setTime(date.getTime() + 3600 * 500)
        // this.courseTime = this.form.courseTime = nomalTime(addTime)
       // this.courseTime = this.form.courseTime = addTime
      },
      _mutualSelect(tab) {
        let date = new Date()
        if (tab === 1) {
          this.mutual = 1
          let addTime  = date.setTime(date.getTime() + 3600 * 500);
          this.courseTime = this.form.courseTime = addTime
          // alert (this.courseTime)
          this.isUseable = false

        } else if (tab === 2) {
          this.mutual = 2
          this.courseTime = this.form.courseTime = date.getTime()
          this.isUseable = true
        }
        // alert(this.mutual)
      },
      _dateChange(picker){
        let date = new Date()
        // if (this.mutual = 1) {
        //   if (picker < date.setTime(date.getTime() + 3600 * 500)) {
        //     // console.log("0000000")
        //     this.courseTime = this.form.courseTime = '';
        //     // this.rules.courseTime[0].message = "最小选择当前时间+30分钟！"
        //   }else{
          this.courseTime = this.form.courseTime =date.setTime(picker.getTime() + 3600 * 5)
          // alert(this.courseTime)
        //   }
        // }
      },
      uploadPic(e) {
        let file = e.target.files
        let formData = new FormData()
        const isJPG = file[0].type != ('image/jpeg' || 'image/jpg')
        const isPNG = file[0].type != 'image/png'
        const isBMP = file[0].type != 'image/bmp'
        const isLt3M = file[0].size / (1024 * 1024) > 3;

        formData.append('attachement', file[0])
        // console.log(file[0] )

        if (isJPG && isPNG && isBMP) {
          this.$message.error('图片格式错误，仅支持PNG、JPG、BMP格式')
          return false
        }
        if (isLt3M) {
          this.$message.error('图片大小不能超过 3MB')
          return false
        }
          axios.post(`${window.BASE_URL}/system/uploadEduImg.json`,formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
            if (res.data.code === _.ERR_OK) {
              this.showImg = true
              this.courseImg = res.data.model.filePathUrl
              saveLocalStorage(res.data.model.filerServerID, 'fileServerID')
              this.imgInfo.push({
                fileName:res.data.model.fileName,
                fileServerID:res.data.model.filerServerID,
                filePathUrl:res.data.model.filePathUrl
              })
              // console.log(this.imgInfo[0].fileServerID)
              // window.open(res.data.model.filePathUrl,'_blank');
            }else{
            }
          }).catch(() => {
          })


        // saveLocalStorage(file.url, 'imgUrl')
        // saveLocalStorage(file.type, 'imgType')
        // alert(file.type)
      },

      _accordionChange(activeNames){
          // console.log(activeNames,"=============")
          if(activeNames === 1){
            this.redactchange1 = "收起"
          }else if(activeNames === 2){
            this.redactchange2 = "收起"
          }else if(activeNames === 3){
            this.redactchange3 = "收起"
          }else{
            this.redactchange1 = "编辑"
            this.redactchange2 = "编辑"

          this.redactchange3 = "编辑"
          }
      },

      __pageSize(payload) {
        this.page.pageSize = payload
        this.tableCaseList()

      },
      __currentPage(val) {
        this.page.currentPage = val
        this.getTableList()
      },
      fileChange(val) {
        this.oldAttachList = val
        this.num3 = val.length
      },
      fileRemove(val) {
        this.attachList.splice(this.attachList.indexOf(val[val.length - 1]), 1)
      },
      _operation_(payload) {
        if (payload.operation === 'icon-yuepian') {
          this.params_image.hospitalId = this.data[payload.index].hospitalId;
          this.params_image.studyPk = this.data[payload.index].studyPk+"";
          this.params_image.studyUid = this.data[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
          // let Aycan = {
          //   hospitalId:this.data[payload.index].hospitalId,
          //   studyPk:this.data[payload.index].studyPk,
          //   studyUid:this.data[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //      let url = res.data.model
          //       window.open(url,'_blank')
          //     // window.open(res.data.model,);
          //   }else{
          //     message('影像调阅失败',false);
          //   }
          // }).catch(() => {
          // })
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.data.splice(payload.index, 1)
            this.num1 -= 1
          })
        }
      },
      _operation2_(payload) {
        if (payload.operation === 'icon-chakan') {
          this.$refs.getCase.openCase(payload.id)
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataVal.splice(this.dataVal.indexOf(payload), 1)
            this.num2 -= 1
          })
        }
      },
      handleCheckChange(data, checked) {
        if (data.dept) return
        if (checked) {
          for (let e of this.treeList) {
            if (e.id.toString() === data.id.toString()) return
          }
          this.treeList.push(data)
        } else {
          for (let i in this.treeList) {
            if (this.treeList[i].id.toString() === data.id.toString()) {
              this.treeList.splice(i, 1)
              break
            }
          }
        }
      },
      handleCheckUser(data, checked) {
        if (data.dept) return
        if (checked) {
          for (let e of this.treeList) {
            if (e.id.toString() === data.id.toString()) return
          }
          this.treeList.push(data)
        } else {
          for (let i in this.treeList) {
            if (this.treeList[i].id.toString() === data.id.toString()) {
              this.treeList.splice(i, 1)
              break
            }
          }
        }
      },
      // _closeBtn(index) {
      //   let e = this.treeList.splice(index, 1)[0]
      //   this.$refs.tree.setCheckedNodes(this.treeList)
      //   if (this.tabLabel === '常用组') {
      //     for (let d of this.data4) {
      //       if (d.id === e.id) {
      //         this.$refs.tree2.setChecked(d, false)
      //       }
      //     }
      //   }
      // },
      _closeUser(index) {
        this.treeList2.splice(index, 1)
        this.$refs.tree2.setCheckedNodes(this.treeList2)
      },
      _saveData() {
        this.popSaveData = true
        var examinePart = "";
        for (let item of this.treeList) {
          examinePart +="," + item.label;
          if (examinePart.substr(0,1)==',')
            examinePart=examinePart.substr(1);
        }
        this.member = examinePart
        if(this.member ==='') {
          this.memberNull = true
          this.memberTrue = false
        } else {
          this.memberNull = false
          this.memberTrue = true
        }
      },
      _addBtn(val) {
        if (val === 1) {
          this.hospitalPop = true
          this.studyList = this.data
          let isModify = getLocalStorage('isModify')
          if(isModify) {
            saveLocalStorage(true, 'trigger')
          }
        } else if (val === 2) {
          this.TableData = []
          this.popCase = true
          this._getTreeData()
          this._getTreeData(1)
          this.tableCaseList()
        } else if (val === 3) {
          this.teachClassPop = true

        }
      },
      getMateriaDetailListData(){
        const ids = this.teachClassData.join(",");
        // const ids = this.teachClassData[0];
        let parmars = {
          id:ids
        };
        http.post("materia/getMateriaDetailList.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            const dataList = res.data.model;
            if(dataList.length>0){
              dataList.forEach(data=>{
                const {caseList,studyList,attachList} = data;
                //获取病例id数组 避免重复添加
                const caseIdList =[];
                this.dataVal.forEach(i =>{
                  caseIdList.push(i.id);
                })
                //获取相关影像增加id数组 避免重复添加
                const studyPkIdList =[];
                this.data.forEach(d =>{
                  studyPkIdList.push(d.studyPk);
                })
                //获取附件名称列表 避免重复添加
                const fileNameList = [];
                this.oldAttachList.forEach(f=>{
                  fileNameList.push(f.attach_name)
                })
                //相关影像增加
                studyList.forEach(item=>{
                  if(studyPkIdList.indexOf(item.studyPk) === -1 ){
                    item.examDate = nomalTime(item.examDate);
                    this.data.push(item);
               /*      console.log(item) */
                    this.num1++;
                  }
                })
                //相关病例增加
                caseList.forEach(item=>{
                  if(caseIdList.indexOf(item.id) === -1 ){
                  if(item.caseSex === '0'||item.caseSex === 'F'){
                     item.caseSex='女'
                    }else{
                     item.caseSex='男'
                   }
                  if(item.privateType === 0){
                    item.privateType='公开'
                  }else{
                    item.privateType='私人'
                  }
                    this.dataVal.push(item);
                    this.num2++;
                  }
                })
                attachList.forEach(item=>{
                  if(fileNameList.indexOf(item.attach_name) === -1 ){
                    item.url = item.fileurl;
                    this.oldAttachList.push(item);
                    if (item.attach_type === 'file') {
                      this.updateFileList.push(item)
                    } else {
                      this.updatePicList.push(item)
                    }
                    this.num3++;
                  }
                })
                })
            }



          }
        });
      },
      teachClassSelect(data){
        this.teachClassData=data;
        if(data.length>0){
          this.getMateriaDetailListData();
        }
         this.teachClassPop = false;
      },
      teachClassSelectClose(){
        this.teachClassPop = false;
      },
      _openScope() {
        this.$refs.getFlag.openFlag()
      },
      closeTeachClass(payload) {
        this.teachClassPop = payload;
      },
      closeHospit(payload) {
        this.hospitalPop = payload;
      },
      receiveClose(){
        this.hospitalPop = false
      },
      closePop(payload) {
        this.pop = payload
      },
      closePopCase(payload) {
        this.popCase = payload
      },
      closePopDetail(payload) {
        this.popDetail = payload
      },
      closeSaveData(payload) {
        this.popSaveData = payload
      },
      _cancelHos() {
        this.pop = false
      },
      _cancelGroup() {
        this.popSaveData = false
      },
      _cancelCanse() {
        this.popCase = false
      },
      _savePopDetail() {
        this.popDetail = false
      },
      _cancel() {
        this.popDetail = false
      },
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      receiveVal(val) {
        if(val.length!==0) {

          this.data = val
          this.hospitalPop = false
          this.num1 = val.length
        }
      },
      tableVal(val) {
        this.medicalVal = val
      },
      ValLength(val) {
        this.number = val
      },
      addDataVal() {
        this.dataVal = []
        this.$refs.getSelection.getList();
        this.popCase = false
        this.dataVal = this.medicalVal
        this.num2 = this.medicalVal.length
      },
      _getTreeData(privateType = 0, keyWord='', subType) {
        let parmars = {
          privateType,
          keyWord,
          subType
        };
        http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (privateType === 0) {
              this.allTreeData = res.data.model;
              this.changeColl('1')
            } else {
              this.oldPersonList = res.data.model;
              this.personList = res.data.model;
            }
          }
        });
      },
      addPersonList(val) {
        this.$prompt('请输入病例名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let parmars = {
            privateType: '1',
            catalogName:　value
          }
          http.post('catalog/addCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      changeColl(playlod) {
        this.defaultTreeChecked = []
        this.filterText = ''
        this.treeData = []
        setTimeout(() => {
          // 1==>部位 2==>诊断 3==>科室
          let [flag, arr] = ['DIANOG', []];
          if (playlod === '1') {
            flag = 'DIANOG';
          } else if (playlod === '2') {
            flag = 'PART';
          } else if (playlod === '3') {
            flag = 'DEPT';
          } else {
            flag = 'CUSTOMER';
          }
          this.treeData = []
          arr = this.allTreeData.filter(item => item.subType === flag)
          for (let item of arr) {
            if (item.parentId === 0) {
              this.treeData.push({
                id: item.id,
                label: item.catalogName,
                children: this.allTreeData.filter(c => c.parentId === item.id)
              })
            }
          }
          for (let item of this.treeData) {
            if (item.children.length > 0) {
              for (let cItem of item.children) {
                cItem.label = cItem.catalogName
              }
            }
          }
        }, 400)
      },
      treeNodeClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      delPerson(val) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let parmars = {
            id: val.id
          }
          http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      getTableList(privateType=0,catalogId) {
        let parmars = Object.assign({
          catalogId,
          privateType,
          keyWord: this.tableKeyWords
        }, this.page)
        http.post('caselib/queryCaseList.json', parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.tableData = res.data.model
            this.page.total = res.data.totalItem
            this.page.currentPage = res.data.currentPage
            for (let item of this.tableData) {
              item.caseSex = _.SEXOBJ[item.caseSex]
              item.privateType = _.privateType[item.privateType]
              if (item.caseAge === undefined) {
                item.ageUnit = ' '
                item.caseAge = ' '
              }else{
                  if (item.ageUnit === '4') {
                    item.caseAge = item.caseAge + '岁'
                  } else if (item.ageUnit === '3') {
                    item.caseAge = item.caseAge + '月'
                  } else if (item.ageUnit === '2') {
                    item.caseAge = item.caseAge + '周'
                  } else if(item.ageUnit === '1'){
                    item.caseAge = item.caseAge + '天'
                  } else if(item.ageUnit === '5'){
                    item.caseAge = item.caseAge + '小时'
                  }
              }
            }
            this.TableData = this.dataVal
          }
        })
      },
      searchClick(val) {
        this.filterText = val
        this.personList = this.oldPersonList.filter(item => item.catalogName.includes(val))
      },
      tableCaseList() {
        this.tableKeyWords = this.search
        this.getTableList(this.personFlag)
        // alert(this.personFlag)
      },
      rightTabChange(payload) {
        this.activeName = payload.name;
        this.rightTabActive = payload.name;
      },
      _radioSelect(tab) {
        if (tab === 1) {
          this.scopeShow = false
          this.openFlag = 1
          // alert(this.openFlag)
        } else if (tab === 2) {
          this.scopeShow = true
          this.openFlag = 2
        }
      },

      tabChange(payload) {
        this.page.currentPage = 1
        this.filterText = ''
        this.personFlag = payload.name
        // console.log(this.oldPersonList)
        this.personList = this.oldPersonList
        if (payload.name === "1") {
          this.isPerson = true;
        } else {
          this.isPerson = false;
        }
        this.getTableList(payload.name)
        // this._getTreeData();
      },
      // stepMove(num) {
      //   this.activeName = (this.activeName - 0 + num).toString();
      //   this.rightTabActive = (this.rightTabActive - 0 + num).toString();
      // },
      getCursetypeList() {  //课程分类
        let params = {
          typeId:'EDU_COURSETYPE'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.cursetypeList = res.data.model
          } else {
          }
        }).catch(err => {
        })
      },
      getSubjectList() {  //学科分类
        let params = {
          typeId:'EDU_SUBJECTTYPE'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.subjectList = res.data.model
            let itemOne = {
              consDesc: "所有",
              consId: ""
            };
            this.subjectList.unshift(itemOne);
          } else {
          }
        }).catch(err => {
        })
      },
      personClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      getUserInfo() {
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.hospitalId = res.data.model.hosId

            this.founder = res.data.model.userId
            this.form.teacher = res.data.model.userName //授课人为创建人
            saveLocalStorage(res.data.model.userName, 'userName')
          } else {
          }
        }).catch(err => {
        })
      },
      _saveCourseName() {
        var members = []
        for (let item of this.treeList) {
          members.push({
            userId: item.id,
            docName: item.label
          })
        }
        let params = {
          groupName: this.GroupName,
          members: members,
        }
        http.post('/system/addMeteriaGroup.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.popSaveData = false
            message("保存成功", true)
          } else {
            message(res.data.msg, false)
          }
        }).catch(err => {
        })
      },
      _AddCourse(form,val) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.openFlag===2){
              if(this.openMember===''){
               message('未选择开放范围')
              } else {

               this.saveReq(val)
              }
            }else{
              this.loading = true
              this.saveReq(val)
            }
          } else {
            return false
          }
        })
      },
      saveReq(onShelfFlag) {
        this.loading = true
        let studyData = []
        for (let item of this.data) {
          studyData.push({
            studyPk: item.studyPk,

          })
        }
        let caseList = []
        for (let item of this.dataVal) {
          caseList.push({
            id: item.id,
            creator: item.creator,
            creatorName: item.creatorName,
            isDelete: item.isDelete,
            caseName: item.caseName
          })
        }
        let SelectSubject
        if(this.selectSubject ==='所有' || this.selectSubject ===''){
          SelectSubject = null
        } else {
          SelectSubject = this.selectSubject
        }

        // for (let item of params.attachList) {
        //   for (let key in item) {
        //     if (
        //       key !== "fileid" &&
        //       key !== "attach_name" &&
        //       key !== "attach_type" &&
        //       key !== "atatch_size"
        //     ) {
        //       delete item[key];
        //     }
        //   }
        // }

        //新增还是修改
        let isModify = getLocalStorage('isModify')
        let detailData = this.$route.params
          //alert(this.$route.params)
        if(isModify === true){

          let isImg = getLocalStorage('fileServerID')
          let addId = ''
          let changedImg

          if (detailData.courseImg != undefined){
            let imgId = detailData.courseImg.split('filePath=')[1].split("&")[0]
          //   if (isImg != imgId){
          //     changedImg = isImg
          //   }else{
          //     changedImg = imgId
          //   }
            changedImg = imgId
          } else{
              changedImg = isImg || ''
          }

          let keyWord = "";
          if(this.keywords.length>0){
            keyWord = this.keywords.join(",")
          }

          addId = detailData.id
            // alert(this.courseTime)
            let params = {
              id: addId,
              subject: this.form.subject,
              onShelfFlag:onShelfFlag, //是否上架
              courseTime:this.courseTime,
              teacher:this.founder,
              teachType:this.mutual,
              courseTypeId: this.selectCurse,
              scienceTypeId: this.selectSubject,
              keyWord ,
              openFlag: this.openFlag,
              courseImg: changedImg,
              remark: this.form.remark,
              caseList: caseList,
              attendList: this.openMemberList,
              studyList: studyData,
              attachList: this.oldAttachList || [],
            }
            let allData = {"course": JSON.stringify(params)}
            // console.log(allData)
            http.post('/course/updateCourse.json', allData).then(res => {
              if (res.data.code === _.ERR_OK) {
                message(res.data.model, true)
                this.$router.go(-1)
                this.loading = false

              } else {
                this.loading = false
                message(res.data.msg, false)
              }
            }).catch(err => {
              this.loading = false
            })
        }else if(isModify === false){
          // console.log( this.imgInfo)
          let ifImg
          if (this.imgInfo.length === 0){
            ifImg = ''
          }else{
            ifImg = getLocalStorage('fileServerID')
          }

          let keyWord = "";
          if(this.keywords.length>0){
            keyWord = this.keywords.join(",")
          }
              let params = {
              // id: addId,
              subject: this.form.subject,
              onShelfFlag:onShelfFlag, //是否上架
              courseTime:this.courseTime,
              teacher:this.founder,
              teachType:this.mutual,
              courseTypeId: this.selectCurse,
              scienceTypeId: this.selectSubject,
              keyWord,
              openFlag: this.openFlag,
              remark: this.form.remark,
              courseImg:ifImg,
              caseList: caseList,
              attendList: this.openMemberList,
              studyList: studyData,
              attachList: this.oldAttachList || [],
            }
            let allData = {"course": JSON.stringify(params)}
            // console.log(allData)
            http.post('/course/addCourse.json', allData).then(res => {
              if (res.data.code === _.ERR_OK) {
                message(res.data.model, true)
                this.$router.go(-1)
                this.loading = false
              } else {
                message(res.data.msg, false)
                this.loading = false
              }
            }).catch(err => {
              this.loading = false
            })

        }

      },
      openMemberVal(val){
        this.openMember = val
      },
      openMemberData(val){
        this.openMemberList = val
      }
    },
    created() {
      this.getUserInfo()
      this.getCursetypeList()
      this.getSubjectList()


      let isModify = getLocalStorage('isModify')
      if(isModify) {
        // let detailData = getLocalStorage('bianjiData')
        let detailData = this.$route.params
        console.log(detailData)
        if(detailData.scienceTypeId===undefined){
          this.selectSubject = ''
        }else{
          this.selectSubject = detailData.scienceTypeId
        }
        if(detailData.courseImg===undefined){
          this.showImg = false
        }else{
          this.showImg = true
        }


        this.form.CurseName = detailData.subject
        this.selectCurse = detailData.courseTypeId
        this.form.remark = detailData.remark
        this.form.subject = detailData.subject
        this.courseTime = this.form.courseTime = detailData.courseTime

        //老版 有可能逗号为中文版的区分一下
        if(detailData.keyWord && detailData.keyWord.length>0){
          if(detailData.keyWord.indexOf("，") !== -1 ){
             this.keywords =detailData.keyWord.split("，")
          }else{
            this.keywords =detailData.keyWord.split(",")
          }

        }

        this.courseImg = detailData.courseImg


        if(detailData.teachType === '1'){      //教学方式
          this.form.mutual = 1
          this.mutual =1

        }else if(detailData.teachType === '2'){
          this.form.mutual = 2
          this.mutual = 2
          this.isUseable = true
        }

        if(detailData.openFlag === '1') {   //公开，私人
          this.scopeShow = false
          this.form.openFlag = 1

        } else if(detailData.openFlag === '2'){
          this.scopeShow = true
          this.form.openFlag = 2
          var examinePart = "";   //开放范围修改部分
          let par = {}
          for (let item of detailData.attendList) {
           if(item.attendType == '3'){
            par = {
              id: item.groupId,
              name: item.groupName,
              job: '',
              attebdType: item.attendType
            }
           }else if(item.attendType =='2'){
            par = {
              id: item.hosId,
              name: item.hosName,
              job: '',
              attebdType: item.attendType
            }
           }else if(item.attendType =='1'){
            par = {
              id: item.deptId,
              name: item.deptName,
              job: item.hosName,
              attebdType: item.attendType
            }
           }else{
            par = {
              id: item.userId,
              name: item.userName,
              job: item.docTitle,
              attebdType: item.attendType
            }
           }
            examinePart +="，" + par.name;
            if (examinePart.substr(0,1)=='，')
              examinePart=examinePart.substr(1);
          }
          this.openMember = examinePart
          this.openMemberList = detailData.attendList
        }
        this.openFlag = detailData.openFlag


        // let studyData = []
        // for (let item of detailData.studyList) {
        //   studyData.push({
        //     studyPk: item.studyPk
        //   })
        // }

        for (let item of detailData.studyList) {    //相关影像
          item.patientSex = changeGender(item.patientSex)
          item.hosArea = changehosArea(item.hosArea)
          item.clinicType = changeclinicType(item.clinicType)
        }
        this.num1 = detailData.studyList.length
        this.data = detailData.studyList


        for (let item of detailData.caseList) {   //相关病例
          item.caseSex =  _.SEXOBJ[item.caseSex]
          item.privateType = _.privateType[item.privateType]
          if (item.caseAge === undefined) {
            item.caseAge = ' '
          } else {
            item.caseAge = item.caseAge + changeAge(item.ageUnit)
          }
        }
        this.num2 = detailData.caseList.length
        this.dataVal = detailData.caseList
       console.log( this.dataVal,'hfjdf')

        if (detailData.attachList.length > 0) {
          for (let item of detailData.attachList) {
            if (item.attach_type === 'file') {
              this.updateFileList.push(item)
            } else {
              this.updatePicList.push(item)
            }
          }
        }
        // for (let item of detailData.attachList) {
        //   delete item.createDate
        // }
        this.num3 = detailData.attachList.length
        this.oldAttachList = detailData.attachList || []

        // this.tableData = this.dataVal
      }else{
        this.defaultTime()
        clearLocalStorage('fileServerID')
      }
    },
    watch: {
      // activeName1(c, o) {
      //   if (c == 'first') {
      //     this.text = '从本院影像选择'
      //     this.addBtn = true
      //   } else if (c == 'second') {
      //     this.text = '从病例库中选择'
      //     this.addBtn = true
      //   } else if (c == 'third') {
      //     this.addBtn = false
      //   }
      // },
      popShow(c) {
        this.getTableList()
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .button-new-tag
    height: 32px;
    vertical-align:top;

  .input-new-tag
    width: 90px;

  .universal
    position: relative
    width: 98%
    min-width: 980px
    margin: auto
    .search
      // margin-bottom: 30px
  .commonAddcourse
    height: calc(100vh - 50px)
    overflow-y: auto
  .addCourse
    height: 46px
    background: $color-background-d
    overflow hidden
    margin-bottom: -10px

  .closeBtn
    width: 18px
    height: 18px
    display: inline-block
    font-size: 15px
    text-align: center
    line-height: 16px
    background: #d7d6d6
    border-radius: 50%
    margin-left: 3px
    color: $color-index-text
    cursor: pointer

  .tabs-content
    overflow: hidden
    background: $color-index-text
  .headTip
    width: 5px;
    height: 18px;
    background: #01abac;
    display: inline-block;
    vertical-align: bottom;
  .addBtn_class
    width: 120px
    height: 27px
    position: relative
    float:right
    right:7%
    line-height: 27px
    text-align: center
    cursor: pointer
    background: #f1a912
    color: $color-index-text
    border-radius: 3px
    display: inline-block


  .addBtn
    width: 120px
    height: 27px
    position: absolute
    right:7%
    line-height: 27px
    text-align: center
    cursor: pointer
    background: $color-btn
    color: $color-index-text
    border-radius: 3px
    z-index: 233
    display: inline-block

  .search
    background: $color-index-text
    padding:15px 0
    height:280px

  ._member
    line-height: 26px !important
    border: 1px solid #dcdfe6

  .memberNull
    height: 26px
  .memberTrue
    height: 400px
    overflow-y: auto
    overflow-x: hidden
  .scient
    position: relative
    left: -8px

  .arrow_first
    position: relative;
    top: 12px;
    left: 130px;

  .rtHeight
    overflow-y: auto

  .overtHeight
    height: 100%

  .rightList
    margin: 5px 10px
    float: left

  .arrow_second
    position: relative
    top: 12px
    left: 250px

  .tabs-text
    position: relative
    top: -34px

  .radius_input
    min-width: 200px
    width: 70%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    position: absolute
    right: 20px
    top: -14px
    padding: 0 20px

  .rSearch
    position: relative
    margin-bottom: 10px

  .point
    position: absolute
    right: 20px
    top: 5px

  ._input
    min-width: 200px
    width: 100%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    right: 20px
    top: -14px
    padding: 0 20px
    box-sizing: border-box;

  .secPoint
    right: 10px

  ._inputTable
    top: 13px

  .btn-box
    text-align: center
    margin-top: 20px
    margin-bottom:10px
    .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin-right: 80px
    .savef
      background: #f2b200
      margin-right: 80px
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
    .cancef
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
      background: #01abac
  .accordion
    background: #fff;
    margin-top:20px
    overflow-x hidden
  .accordion .el-collapse-item__header
    height:60px !important
  .titletext
    margin-left:70px
    color:#8a8f99
  .titletext span
    font-size: 16px
    color:#01abac
  .font1
    font-size:15px
  .redact
    position: absolute
    right: 3%


  .avatar-uploader
    border: 1px solid #d9d9d9
    cursor: pointer
    position: relative
    // overflow: hidden
    width:120px
    height:90px
    z-index:99
  .file-upload
    position:absolute;
    z-index:1;
    opacity:0;
    background:transparent
    cursor:pointer;
    width: 100%;
    height 100%
    z-index 1000

  .avatar-uploader:hover
    border-color: #409EFF

  .avatar-uploader-icon
    font-size: 30px
    font-weight:bold
    color: #c2c5cc
    position:absolute
    width:100%
    top:-20px
    left:45px
    z-index -1
  .upper-txt
    font-size 12px

  .avatar
    width: 120px
    height: 90px
    display: block
    position: absolute;
    top: 0;
    z-index: 100;

  .avatar-icon
    font-size: 14px
    color: #c2c5cc
    width: 150px
    height: 120px
    line-height: 120px
    text-align: center
    position:relative
    top:20px
    left:-55px

  .blocktime
    position:relative
    top:-40px
    left:160px
</style>



// WEBPACK FOOTER //
// newCourse.vue?77c2a738